<div class="row" cdkDropListGroup>
  <div class="col-6 ">
    <div class="card" style="margin-left: 40px; margin-right: 20px; ">
      <div class="card-body">
        <h5 class="card-title">{{firstListType | translate}}</h5>
        <div class="row" >
          <div class="col-2"></div>
          <div class="col-8">
            <ng-multiselect-dropdown *ngIf="firstList?.length > 1"  [settings]="dropdownSettings" [placeholder]="'Seleziona'"
                                     [data]="firstList" [(ngModel)]="firstMagazzino" (ngModelChange)="onMagazzinoSelect($event)">
            </ng-multiselect-dropdown>
          </div>
          <div class="col-2"></div>
          <div class="col-12" >
            <div class="taskboard-cards" cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListData]="prodotti">
              <div class="furgone-card cursor-pointer" style="" cdkDrag *ngFor="let item of prodotti" [ngStyle]="{'background-color': 'rgba(255, 255, 255, 0.1)'}">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="taskboard-title font-medium">{{ item.prodotto }}</div>
                  <div class="taskboard-title font-medium">Disponibili: {{ item.magazzino - spostati(item)}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-6 ">
    <div class="card" style="margin-left: 20px; margin-right: 40px; ">
      <div class="card-body">
        <h5 class="card-title">{{secondListType | translate}}</h5>
        <div class="furgone-card" *ngFor="let item of secondList" cdkDropList (cdkDropListDropped)="drop($event, item)" [cdkDropListData]="item.prodotti">
          <span class="font-18" style="margin-block: 15px"  >{{item.nome}}</span>
          <div class="" >
            <div class="prodotto-card cursor-pointer"  *ngFor="let prodotto of item.prodotti" cdkDrag  [ngStyle]="{'background-color': 'rgba(255, 255, 255, 0.1)'}">
              <div class="d-flex justify-content-between align-items-center">
                <div class="taskboard-title font-medium">{{ prodotto.prodotto }}</div>
                <input class="form-control" style="max-width: 250px;" [(ngModel)]="prodotto.qta" (ngModelChange)="quantityChange(prodotto, item, $event)" type="number" step="1" min="1">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<aside  style="position: fixed; bottom: 20px; right: 0;"  >
      <button type="submit" (click)="Salva()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Salva </span>
        <i-feather name="save" class="feather-sm "></i-feather>
      </button>
</aside>
